import { getEnv } from '@/modules/server/helpers-client';
export const API_PATH = '/api';
export const INTERNAL_API_PATH = '/internal';

export const CASINO_PAYMENTS_REDIRECT_ROUTES = {
  SUCCESS: '/deposit/success',
  FAILURE: '/deposit/failure',
  PENDING: '/deposit/pending',
  SUPPORT: '/',
};

export const PUBLIC_URL = 'https://www.levelupcasino.com';

export const ONE_SIGNAL_APP_IDS = {
  MAIN: '1f90e576-ce9c-4270-997c-788b16e79c6a',
  MIRROR_2: 'b9fb74f9-1603-4a27-ac8f-25ac84146484',
  MIRROR_8: '8b866b28-37af-4bff-b9fc-851a72f26e40',
  MIRROR_10: 'd440edab-d108-40ff-a27d-98c55bb67624',
  // AU
  MIRROR_30: '6cd3af35-e132-41af-a902-2ffa19f23fc4',
  MIRROR_35: '40b410b6-4f75-4ade-ab12-3ee13ed9d7fc',
};

export const DOMAINS = {
  MAIN: 'levelupcasino.com',
  MAIN_IO: 'levelup.casino',
  DEV: 'next.lv01-dev.k8s.levelupcasino2.com',
  DEV_2: 'webapp-lv01-dev.levelupcasino2.com',
  LOCAL: 'localhost',
  MIRROR_1: 'levelupcasino1.com',
  MIRROR_2: 'levelupcasino2.com',
  MIRROR_3: 'levelupcasino3.com',
  MIRROR_4: 'levelupcasino4.com',
  MIRROR_5: 'levelupcasino5.com',
  MIRROR_7: 'levelupcasino7.com',
  MIRROR_8: 'levelupcasino8.com',
  MIRROR_10: 'levelupcasino10.com',
  MIRROR_30: 'levelupcasino30.com',
  MIRROR_35: 'levelupcasino35.com',
  OTHER: 'levelup.casino',
  PROMO: 'promo.levelupcasino.com',
  SANDBOX: 'levelup-sandbox.com',
};

export const REQUEST_TIMEOUT = 60;
export const CACHE_REVALIDATE_TIMEOUT = 0;

export const PLAYER_ACCOUNTS_KEY = '/player/accounts?compatibility=false';

export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS = 10;
export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS_TTL = 10_800_000;

export const X_SELL_USER_API = 'https://v1.xsell-lup.xyz/api/users';

export const TOURNAMENT_SS_WIDGETS =
  'https://iframe.a8r.games/widgets/latest/index.js?id={}';

export const TOURNAMENT_LEADERBOARD_WIDGET_URL = 'https://api.lobby.a8r.games';

const envs = getEnv();

export const CLIENT_ENVS = {
  // Build env variables
  APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,

  // Runtime env variables
  CDN_URL: envs.NEXT_RUNTIME_PUBLIC_CDN_URL,
  CDN_URL_FALLBACK_1: envs.NEXT_RUNTIME_PUBLIC_CDN_URL_2,
  CDN_URL_FALLBACK_2: envs.NEXT_RUNTIME_PUBLIC_CDN_URL_3,
  CMS_S3_URL: envs.NEXT_RUNTIME_PUBLIC_CMS_S3_URL,
  CMS_CDN_URL: envs.NEXT_RUNTIME_PUBLIC_CMS_CDN_URL,
  BQ_API_URL: envs.NEXT_RUNTIME_PUBLIC_BQ_API_URL,
  JACKPOT_API_URL: envs.NEXT_RUNTIME_PUBLIC_JACKPOT_API_URL,
  CDN_ICON_URL: envs.NEXT_RUNTIME_PUBLIC_CDN_ICON_URL,
  IMG_CDN_URL: envs.NEXT_RUNTIME_PUBLIC_IMG_CDN_URL,
  CMS_URL: envs.NEXT_RUNTIME_PUBLIC_CMS_URL,
  TOURNAMENT_SS_WIDGETS: envs.NEXT_RUNTIME_PUBLIC_TOURNAMENT_SS_WIDGETS,
  GAMIFICATION_API: envs.NEXT_RUNTIME_PUBLIC_GAMIFICATION_API,
  SENTRY_DSN: envs.NEXT_RUNTIME_PUBLIC_SENTRY_DSN,
  SENTRY_ENVIRONMENT: envs.NEXT_RUNTIME_PUBLIC_SENTRY_ENVIRONMENT,
  SENTRY_CSP_URI: envs.NEXT_RUNTIME_PUBLIC_SENTRY_CSP_URI,
  GTM_ID: envs.NEXT_RUNTIME_PUBLIC_GTM_ID,
  GA_MEASUREMENT_ID: envs.NEXT_RUNTIME_PUBLIC_GA_MEASUREMENT_ID,
  CMS_VERSION: envs.NEXT_RUNTIME_PUBLIC_CMS_VERSION,
  I18NEXUS_REFRESH_TIME: envs.NEXT_RUNTIME_PUBLIC_I18NEXUS_REFRESH_TIME,
  I18NEXUS_API_KEY: envs.NEXT_RUNTIME_PUBLIC_I18NEXUS_API_KEY,
  ABSTRACT_API_KEY: envs.NEXT_RUNTIME_PUBLIC_ABSTRACT_API_KEY,
  ORGANIC_PROMO_URL: envs.NEXT_RUNTIME_PUBLIC_ORGANIC_PROMO_URL,
};

export const CDN_URLS = [
  CLIENT_ENVS.CDN_URL,
  CLIENT_ENVS.CDN_URL_FALLBACK_1,
  CLIENT_ENVS.CDN_URL_FALLBACK_2,
].filter(Boolean) as string[];

export const EXCLUDED_CDN_DOMAINS = [
  CLIENT_ENVS.CMS_CDN_URL,
  CLIENT_ENVS.CDN_URL,
  CLIENT_ENVS.CDN_URL_FALLBACK_1,
  CLIENT_ENVS.CDN_URL_FALLBACK_2,
  CLIENT_ENVS.CDN_ICON_URL,
  //TODO: After deploy fix images from cms, redownload images in cms
  's3.ap-southeast-2.amazonaws.com',
  'https://local-testing-cms.s3.eu-central-1.amazonaws.com',
];

const EE_LICENSE_REGULATOR_IP = '46.22.220.41';

export const WHITELIST_IPS = [EE_LICENSE_REGULATOR_IP];

export const FREESPINS_QUANTITY = 50;
export const BONUSES_QUANTITY = 50;

export const REQUEST_RETRIES = 3;
